import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 创建或编辑一个干预方案
 * @param vCom Vue组件
 */
const editGanyu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/intervene/save_intervene_way", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 干预方案详情
 * @param vCom Vue组件
 */
const GanyuDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/intervene/intervene_way_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增、编辑科普
 * @param vCom Vue组件
 */
const EditKepu = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/kepu/kepu", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取科普列表
 * @param vCom Vue组件
 */
const GetKepuList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/kepu/kepu_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取科普详情
 * @param vCom Vue组件
 */
const GetKepuDetail = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/kepu/kepu", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除科普
 * @param vCom Vue组件
 */
const DelKepu = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/kepu/kepu", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取知识库列表
 * @param vCom Vue组件
 */
const GetKnowledgeList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/cmn/knowledge_base_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取知识库详情
 * @param vCom Vue组件
 */
const GetKnowledgeDetail = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/cmn/knowledge_base", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除知识库记录
 * @param vCom Vue组件
 */
const DelKnowledge = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/cmn/knowledge_base", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新建或修改知识库记录
 * @param vCom Vue组件
 */
const EditKnowledge = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/cmn/knowledge_base", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 字典查询
 * @param vCom Vue组件
 */
const GetZidian = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/cmn/param_value_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取检查检验库列表
 * @param vCom Vue组件
 */
const GetJianchaJianyanList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/consultation/inspect_templates", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增检查检验库数据
 * @param vCom Vue组件
 */
const AddJianchaJianyanList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/consultation/inspect_templates", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 编辑检查检验库数据
 * @param vCom Vue组件
 */
const EditJianchaJianyanList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.put("api/consultation/inspect_templates", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除检查检验库数据
 * @param vCom Vue组件
 */
const DelJianchaJianyanList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/consultation/inspect_templates", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取检查检验项目名称
 * @param vCom Vue组件
 */
const getAllInspect = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/consultation/inspect_names", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 获取指标库列表
 * @param vCom Vue组件
 */
const getZhibiaoList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/consultation/index_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 新增、编辑指标
 * @param vCom Vue组件
 */
const editZhibiao = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/consultation/indexes", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 删除指标
 * @param vCom Vue组件
 */
const delZhibiao = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/consultation/indexes", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 获取测评列表
 * @param vCom Vue组件
 */
const GetCepingList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/admin_template_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 获取测评列表
 * @param vCom Vue组件
 */
const EditCeping = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 获取评估类型列表
 * @param vCom Vue组件
 */
const GetCepingTypeList = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template_category_list").then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 编辑评估类型
 * @param vCom Vue组件
 */
const EditCepingPinggu = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template_category_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
export {
    editGanyu, GanyuDetail, EditKepu, GetKepuList, GetKepuDetail, DelKepu,
    GetKnowledgeList, GetKnowledgeDetail, DelKnowledge, EditKnowledge, GetZidian,
    GetJianchaJianyanList, AddJianchaJianyanList, EditJianchaJianyanList,
    DelJianchaJianyanList, getAllInspect, getZhibiaoList, editZhibiao, delZhibiao,
    GetCepingList, GetCepingTypeList, EditCepingPinggu, EditCeping
}
